import $ from 'jquery';

$(document).ready(function(){
var interval = 5000;
var divs = $('.cw-new-theme .enquiry-ribbon h3 a');
var currentIndex = 0;

function showNextDiv() {
divs.hide();
divs.eq(currentIndex).fadeIn();
currentIndex = (currentIndex + 1) % divs.length;
}

setInterval(showNextDiv, interval);
divs.hide();
showNextDiv();

});



// WEBPACK FOOTER //
// ./components/cw-header/scripts/_cw-sticky-topbar.js